<template>
  <div id="data-list-list-view" class="data-list-container">

    <vx-card v-if="filter" ref="filterCard" :title="$t('Filter')" class="user-list-filters mb-4" actionButtons @refresh="initInput" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mb-2" >{{ $t("room") }} </p>
          <v-select :options="salles"
          @search="getSalle" :clearable="true" label="libelle" v-model="salleSaisie" class="w-full"/>
        </div>

        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mb-2" >{{ $t("type_of_fees") }} </p>
          <v-select :options="typeFraiss"
          @search="getTypeFraiss" :disabled="salleSaisie? false : true" :clearable="true" label="libelle" v-model="typeFraisSaisie" class="w-full"/>
        </div>

        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mb-2" >{{ $t("Slice") }} </p>
          <v-select :options="tranches"
          :disabled="typeFraisSaisie? false : true" :clearable="true" label="libelle" v-model="trancheSaisie" class="w-full"/>
        </div>
      </div>
      <!-- <div class="vx-row">
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
          <p class="mt-4" > {{ $t('Start_date') }} </p>
            <datepicker v-model="input.dateDebut" :disabled="input.typeFrais? false : true" name="dateDebut"></datepicker>
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
          <p class="mt-4" > {{ $t('End_date') }} </p>
            <datepicker v-model="input.dateFin" :disabled="input.typeFrais? false : true" name="dateDebut"></datepicker>
        </div>
      </div> -->
    </vx-card>

    <vs-table :noDataText="$t('No_data_Available')" ref="table" :data="inscriptions">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div
            v-if="typeFraisSaisie"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="getPdfOfTranche"
          >
            <feather-icon icon="FileIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"> Imprimer </span>
          </div>

          <vx-tooltip :text="$t('Filterlist')" color="warning">
            <div class="btn-add-new p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning" @click="filter=!filter">
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            </div>
          </vx-tooltip>
        </div>
        <ul class="demo-alignment" v-if="trancheSaisie">
            <li>
                <vs-radio v-model="solved" :vs-value="false" color="danger" > Non soldé </vs-radio>
            </li>
            <li>
                <vs-radio color="success" v-model="solved" :vs-value="true"> Soldé </vs-radio>
            </li>
        </ul>
        <div class="flex flex-wrap">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ param.paginate.page * param.paginate.length - (param.paginate.length - 1) }} - {{ taille - param.paginate.page * param.paginate.length > 0 ? param.paginate.page * param.paginate.length : taille }} {{ $t("of_sur") }} {{ taille }}</span>
              <feather-icon icon="ChevronDownIcon" svgInscriptions="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item :key="indexItem" v-for="(item, indexItem) in itemsPerPages" @click="param.paginate.length=item, getFraisInscriptions()">
                <span> {{item}} </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input icon-pack="feather" icon="icon-search" :placeholder="$t('Search')" v-model="search" class="is-label-placeholder mb-8" />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="inscription.eleve.matricule">{{ $t("Registration_number") }}</vs-th>
        <vs-th sort-key="inscription.eleve.full_name">{{ $t("full_name") }}</vs-th>
        <vs-th sort-key="inscription.statutEleve.libelle">{{ $t("Student_status") }}</vs-th>
        <vs-th sort-key="inscription.eleve.sexe.code">{{ $t("sex") }}</vs-th>
        <vs-th>{{ $t("Total_amount") }}</vs-th>
        <vs-th> Total Payer </vs-th>
        <vs-th>{{ $t("Remaining_mount") }}</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.eleve.matricule }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.eleve.full_name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.statutEleve.libelle }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.eleve.sexe.code }}</p>
              </vs-td>

              <vs-td style="text-align: right;">
                <p class="product-name font-medium truncate">{{ new Intl.NumberFormat('de-DE').format(tr.montantTotal) }}</p>
              </vs-td>

              <vs-td style="text-align: right;">
                <p class="product-name font-medium truncate">{{ new Intl.NumberFormat('de-DE').format(tr.totalPayer) }}</p>
              </vs-td>

              <vs-td style="text-align: right;">
                <p class="product-name font-medium truncate">{{ new Intl.NumberFormat('de-DE').format(tr.reste) }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <div class="items-center">
      <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
    </div>

  </div>
</template>

<script>
let base_self = ''
import moduleDataList from '@/store/data-list/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'

// Inscription
const input_tempon = {
  salle: '',
  classe: '',
  typeFrais: '',
  tranche: '',
  dateDebut: '',
  dateFin: ''
}

export default {
  components: {
    Datepicker
  },
  data () {
    return {
      inscriptionsObject: {},
      inscriptions: [],
      inscriptionsTempon: [],
      paramInscription: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: [],
          abandon: false,
          anneeScolaire__cloture: false,
          anneeScolaire__encours: true
        },
        orderby: ['eleve__full_name'],
        juste: {
          id: '',
          eleve: {
            id: '',
            matricule: '',
            full_name: '',
            sexe: {
              code: ''
            }
          },
          statutEleve: {
            libelle: ''
          }
        }
      },
      salleSaisie: null,
      typeFraisSaisie: null,
      trancheSaisie: null,
      solved: false,
      typeFraiss: [],
      salles: [],
      classes: [],
      tranches: [],
      objectTrancheMontant: {},
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      filter: true,
      search: '',
      param: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {}
      },
      paramSalle: {},
      paramTypeFrais: {},
      paramTranches: {},
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      selected: [],
      fraisInscriptions: [],
      isMounted: false,
      sidebarData: {}
    }
  },
  watch: {
    salleSaisie (value) {
      if (value) {
        base_self.getTypeFraissSimple()
      } else {
        base_self.typeFraiss = []
      }

      base_self.typeFraisSaisie = null
      base_self.trancheSaisie = null
    },
    typeFraisSaisie (value) {
      if (value) {
        base_self.getInscription()
        base_self.getTranchesSimple()
        base_self.trancheSaisie = null
      } else {
        base_self.inscriptions = []
        base_self.tranches = []
        base_self.trancheSaisie = null
      }
    },
    trancheSaisie (value) {
      if (value) {
        setTimeout(() => {
          base_self.filtreParTranche()
          console.log(' okkk ---------------- kk ')
          console.log(' okkk ---------------- kk ')
        }, 1000)

      } else {
        base_self.getInscription()
      }
    },
    solved () {
      if (base_self.trancheSaisie) {
        base_self.filtreParTranche()
      }
    },
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getFraisInscriptions()
    },
    search (value) {
      if (value.length) {
        base_self.param.filter.q_list = [
          { 'inscription_eleve__matricule__icontains': value },
          { 'inscription_eleve__full_name__icontains': value },
          { 'inscription_statutEleve__libelle__icontains': value },
          { 'inscription_eleve__dateEntree__icontains': value },
          { 'inscription_eleve__naissance__icontains': value },
          { 'inscription_eleve__sexe__code__icontains': value }
        ]
      } else {
        base_self.param.filter.q_list = []
      }
      base_self.getFraisInscriptions()
    }
    // eslint-disable-next-line no-unused-vars
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    getPdfOfTranche () {
      /* 
        matricule
        full_name
        montantTotal
        totalPayer
        reste
      */

      /* const inscriptions = []

      for (let i = 0; i < base_self.inscriptions.length; i++) {
        const item = base_self.inscriptions[i]

        inscriptions.push({
          matricule: item.eleve.matricule,
          full_name: item.eleve.full_name,
          montantTotal: item.montantTotal,
          totalPayer: item.totalPayer,
          reste: item.reste
        })
      }

      const objetAEnvoyer = {
        inscriptions,
        salle: base_self.salleSaisie.id,
        typeFrais: base_self.typeFraisSaisie.id,
        solved: base_self.solved
      } */

      let montant = 0
      let tranche = 0
      if (base_self.trancheSaisie && base_self.trancheSaisie.id) {
        montant = base_self.objectTrancheMontant[base_self.trancheSaisie.id]
        tranche = base_self.trancheSaisie.id
      }

      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/liste_eleve_solder/${base_self.salleSaisie.id}/${base_self.typeFraisSaisie.id}/${tranche}/${montant}/${ base_self.solved ? 1 : 0 }`, '_blank')
    },
    filtreParTranche () {
      if (base_self.trancheSaisie) {
        // console.log('base_self.inscriptionsTempon: ', base_self.inscriptionsTempon)
        const montant = base_self.objectTrancheMontant[base_self.trancheSaisie.id]

        const inscriptions = []

        for (let i = 0; i < base_self.inscriptionsTempon.length; i++) {
          if ((!base_self.solved && base_self.inscriptionsTempon[i].totalPayer < montant) || (base_self.solved && base_self.inscriptionsTempon[i].totalPayer >= montant)) {
            inscriptions.push(base_self.inscriptionsTempon[i])
          }
        }

        base_self.inscriptions = JSON.parse(JSON.stringify(inscriptions))
      }
    },
    async getRecu (inscriptions) {
      console.log('inscriptions: ', inscriptions)
      console.log('inscriptions: ', inscriptions)
      const data3 = {
        is_get: true,
        paginate: {
          length: 1000000,
          page: 1
        },
        filter: {
          frais__id: base_self.fraisSortie.id,
          annuler: false
        },
        juste: {
          montant: '',
          inscription: {
            id: ''
          }
        }
      }

      const response_3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Recu`, data3)
        .catch((error) => {
          console.log('error: ', error)
        })

      const length_3 = response_3.data.data.length
      for (let uioy = 0; uioy < length_3; uioy++) {
        const item = response_3.data.data[uioy]

        if (inscriptions[base_self.inscriptionsObject[item.inscription.id]]) {
          inscriptions[base_self.inscriptionsObject[item.inscription.id]].totalPayer += item.montant
          inscriptions[base_self.inscriptionsObject[item.inscription.id]].reste -= item.montant
        }
      }

      base_self.inscriptions = JSON.parse(JSON.stringify(inscriptions))
      base_self.inscriptionsTempon = JSON.parse(JSON.stringify(inscriptions))
    },
    async getInscription () {
      if (base_self.salleSaisie && base_self.typeFraisSaisie) {

        console.log(' je suis erentrer dans base_self.salleSaisie && base_self.typeFraisSaisie: ')
        const data = {
          is_get: true,
          paginate: {
            length: 10,
            page: 1
          },
          filter: {
            classe__id: base_self.salleSaisie.classe.id,
            typeFrais__id: base_self.typeFraisSaisie.id,
            anneeScolaire__encours: true,
            anneeScolaire__cloture: false
          }
        }

        const response3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Frais`, data)
          .catch((error) => {
            console.log('error: ', error)
          })
        
        console.log('--- simple response3.data.data: ', response3.data.data)
        if (response3.data.data.length === 1) {
          base_self.fraisSortie = response3.data.data[0]
          base_self.paramInscription.filter['statutEleve__fraiss__id'] = base_self.fraisSortie.id
        } else {
          base_self.fraisSortie = {
            montant: 0
          }
          delete base_self.paramInscription.filter['statutEleve__fraiss__id']
        }

        base_self.paramInscription.filter['salle__id'] = base_self.salleSaisie.id
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
          .then((response) => {
            const inscriptionsObject = {}

            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i].montantTotal = base_self.fraisSortie.montant
              response.data.data[i].totalPayer = 0
              response.data.data[i].reste = base_self.fraisSortie.montant

              inscriptionsObject[response.data.data[i].id] = i
            }
            
            base_self.inscriptionsObject = inscriptionsObject
            base_self.taille = response.data.data.length

            console.log('----------------------response3.data.data: ', response3.data.data)
            console.log('----------------------base_self.fraisSortie: ', base_self.fraisSortie)
            if (base_self.fraisSortie.id) {
              console.log('response3.data.data: ', response3.data.data)

              base_self.getRecu(response.data.data)
            }
          })
          .catch((error) => {
            console.log('error: ', error)
          })

      }
    },
    seePicture (link) {
      if (!link) return ''

      link = link.substring(1)
      return `${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}${link}`
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.$refs.filterCard.removeRefreshAnimation()
    },
    getSalleSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 10,
          page: 1
        },
        filter: { is_active: true, classe__is_active: true, classe__niveau__is_active: true },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: ''
          }
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 10,
          page: 1
        },
        filter: { is_active: true, classe__is_active: true, classe__niveau__is_active: true, libelle__icontains: search },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: ''
          }
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      }
      
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getClasseSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true, libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getTypeFraissSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { fraiss__classe__id: base_self.salleSaisie.classe.id, fraiss__anneeScolaire__id: base_self.$store.state.anneeScolaire.id, fraiss__is_active: true }
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeFrais`, data)
        .then((response) => {
          base_self.typeFraiss = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getTypeFraiss (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { fraiss__classe__id: base_self.salleSaisie.classe.id, fraiss__is_active: true, fraiss__anneeScolaire__id: base_self.$store.state.anneeScolaire.id, libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeFrais`, data)
        .then((response) => {
          base_self.typeFraiss = response.data.data
          loading(false)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    async getTranchesSimple () {
      if (base_self.typeFraisSaisie && base_self.typeFraisSaisie.id) {
        const data3 = {
          is_get: true,
          paginate: {
            length: 50,
            page: 1
          },
          filter: {
            frais__anneeScolaire__encours: true,
            frais__anneeScolaire__cloture: false,
            frais__typeFrais__id: base_self.typeFraisSaisie.id,
            frais__classe__id: base_self.salleSaisie.classe.id
          },
          orderby: ['ordre']
        }
        const response_3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Tranche`, data3)
          .catch((error) => {
            console.log('error: ', error)
          })
        base_self.tranches = []
        base_self.tranches = response_3.data.data

        let sommeTotal = 0.0
        const objectTrancheMontant = {}

        for (let i = 0; i < base_self.tranches.length; i++) {
          sommeTotal += base_self.tranches[i].montant

          base_self.tranches[i].libelle = `Tranche ${base_self.tranches[i].ordre} ( ${new Intl.NumberFormat('de-DE').format(base_self.tranches[i].montant)} )`

          objectTrancheMontant[base_self.tranches[i].id] = sommeTotal
        }

        base_self.objectTrancheMontant = objectTrancheMontant

        if (base_self.tranches.length === 1) {
          base_self.trancheSaisie = base_self.tranches[0]
        }
      }
    },

    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },

    async getFraisInscriptions () {
      if (
        base_self.input.classe &&
        base_self.input.classe.id &&
        base_self.input.salle &&
        base_self.input.salle.id &&
        base_self.input.typeFrais &&
        base_self.input.typeFrais.id
      ) {
        base_self.$vs.loading()
        /*if ((base_self.input.dateDebut || base_self.input.dateDebut !== '') && (base_self.input.datFin || base_self.input.dateFin !== '')) {
          base_self.param.filter['createdAt'] = base_self.solved
        } else {
          delete base_self.param.filter['']
        }*/
        base_self.param.filter['enRegle'] = base_self.solved
        if (base_self.input.tranche && base_self.input.tranche.id) {
          const param = {
            is_get: true,
            paginate: {
              length: 50,
              page: 1
            },
            filter: {
              tranche__frais__classe: base_self.input.classe.id,
              inscription__salle: base_self.input.salle.id,
              tranche__frais__typeFrais: base_self.input.typeFrais.id,
              tranche__frais__anneeScolaire__id: base_self.$store.state.anneeScolaire.id,
              enRegle: base_self.solved,
              tranche__id: base_self.input.tranche.id
            }
          }
          console.log('param Tranch', param)
          base_self.$http.post(`${base_self.$store.state.route_for_esm}TrancheInscription`, param)
            .then((response) => {
              console.log('resposne', response.data.data)
              base_self.fraisInscriptions = response.data.data
              base_self.taille = response.data.taille
              base_self.$vs.loading.close()
            })
            .catch(() => {
              window.getESM.error(base_self.$t('The_server_is_not_responding'))
              base_self.$vs.loading.close()
            })
        } else {
          console.log(' .......................  response  .......................')
          console.log(' #######################  response  #######################')
          console.log(' .......................  response  .......................')

          base_self.param.filter['frais__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
          base_self.param.filter['inscription__salle'] =  base_self.input.salle.id
          base_self.param.filter['frais__typeFrais'] = base_self.input.typeFrais.id
          console.log('param Tranch', base_self.param)
          base_self.$http.post(`${base_self.$store.state.route_for_esm}FraisInscritption`, base_self.param)
            .then((response) => {
              console.log('response', response.data.data)
              base_self.fraisInscriptions = response.data.data
              base_self.taille = response.data.taille
              base_self.$vs.loading.close()
            })
            .catch(() => {
              window.getESM.error(base_self.$t('The_server_is_not_responding'))
              base_self.$vs.loading.close()
            })
        }
      }
    }
  },
  created () {
    base_self = this
    base_self.getSalleSimple()

    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('dataList/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}

</style>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
